import { render } from "./WaiverPending.vue?vue&type=template&id=0fd5dead&scoped=true"
import script from "./WaiverPending.vue?vue&type=script&lang=js"
export * from "./WaiverPending.vue?vue&type=script&lang=js"

import "./WaiverPending.vue?vue&type=style&index=0&id=0fd5dead&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd5dead"]])

export default __exports__